export const getMifidQuoteId = (negotiationId: string, quoteId: string) =>
  `${negotiationId}/${quoteId}`;
